import { useCallback } from 'react';
import { callApi } from '../api/callApi';
import { API_ENDPOINT, API_URL_ORDER_SERVICE } from '../api/constant';

const useDownloadInvoice = () => {
  const downloadInvoice = useCallback(async (orderId: string) => {
    try {
      const html = await callApi(
        `${API_URL_ORDER_SERVICE}${API_ENDPOINT.order}/invoice/${orderId}`,
        { method: 'GET', responseType: 'text' },
      );

      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = '0';

      document.body.appendChild(iframe);

      iframe.contentDocument!.open();
      iframe.contentDocument!.write(html);
      iframe.contentDocument!.close();

      iframe.contentWindow!.print();

      setTimeout(() => iframe.remove(), 1000);
    } catch (err) {}
  }, []);

  return { downloadInvoice };
};

export default useDownloadInvoice;
